var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('IeUsersMessage'),_c('Header',{attrs:{"public":"","scroll-position":_vm.scrollPosition}}),_c('main',{staticClass:"layout__main"},[_c('nuxt')],1),_c('Footer'),_c('Cookies'),_c('NoConnectionNotification'),_c('BLoading',{attrs:{"active":_vm.isAuthLoading,"can-cancel":false,"is-full-page":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }